import { useQuery } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryKeys } from './queryKeys';
import { ExternalSystemId, ModelGroupDTO } from './useModelGroupsQuery';

export interface OrionModelOptionDTO {
  id: number;
  name: string;
  riskScore: number | null;
}

const fetchOrionModelOptions = (): Promise<OrionModelOptionDTO[]> => {
  return authFetch('/Adviser/OrionModelImport/AvailableModels');
};

interface OrionModelOptionsQueryParams {
  modelGroup: Partial<ModelGroupDTO>;
}

export const useOrionModelOptionsQuery = ({ modelGroup }: OrionModelOptionsQueryParams) => {
  return useQuery(
    queryKeys.orionModelOptions(),

    () => fetchOrionModelOptions(),

    {
      enabled: modelGroup.externalSystem === ExternalSystemId.Orion,
    },
  );
};
